<template>
    <img :src="imagePath ? $resourcePath + imagePath : empty_image" :style="{ border: isShowBorder ? borderStyle : '', borderRadius: isWithoutRadius ? '' : '50%' }" @error="(e) => { e.target.src = empty_image }">
</template>

<script>
import { MEMBER_TYPE } from "../../Constants";

export default {
    name: "ProfileImage",
    props: {
        imagePath: {
            type: String,
            default: null
        },
        writerType: {
            type: [String, Number],
            default: MEMBER_TYPE.USER
        },
        isShowBorder: {
            type: Boolean,
            default: true,
        },
        isWithoutRadius: {
            type: Boolean,
            default: false,
        },
        isThumbnail: {
            type: Boolean,
            defualt: false,
        },
        borderStyle: {
            type: String,
            default: '1px solid lightgray'
        }
    },
    computed: {
        empty_image() {
            if (this.isThumbnail) {
                return this.$Util.getJoinThumbnailEmpty(1);
            }

            if (this.isWithoutRadius) {
                // return this.writerType == MEMBER_TYPE.USER ? require('@/assets/profile_square.png') : require('@/assets/profile_coach_square.png')
                return this.writerType == MEMBER_TYPE.USER ? require('@/assets/recommend_profile/basic_profile.png') : require('@/assets/recommend_profile/basic_profile.png')
            } else {
                // return this.writerType == MEMBER_TYPE.USER ? require('@/assets/profile.png') : require('@/assets/profile_coach.png')
                return this.writerType == MEMBER_TYPE.USER ? require('@/assets/recommend_profile/basic_profile.png') : require('@/assets/recommend_profile/basic_profile.png')
            }
        }
    },
    data() {
        return {
            MEMBER_TYPE: MEMBER_TYPE,
        }
    },
}
</script>

<style scoped></style>